import { Component } from '@angular/core';
import { WatchAwareComponent } from 'src/app/watch-aware.component';
import { Graffiti } from 'src/graphics/graffiti';
import { Mouse } from 'src/graphics/mouse';
import { Kb } from 'src/util/kb';

@Component({
    selector: 'app-control-graffiti',
    templateUrl: './control-graffiti.component.html',
    styleUrls: ['./control-graffiti.component.scss'],
    standalone: false
})
export class ControlGraffitiComponent extends WatchAwareComponent {
    public size = Graffiti.size;
    public min = 1;
    public max = 100;
    public decreaseSubscription = Kb.on({ code: 'BracketLeft' }, () => { this.update(Graffiti.size() - 1); Mouse.draw(); });
    public increaseSubscription = Kb.on({ code: 'BracketRight' }, () => { this.update(Graffiti.size() + 1); Mouse.draw(); });

    public override ngOnDestroy() {
        super.ngOnDestroy();
        this.decreaseSubscription.unsubscribe();
        this.increaseSubscription.unsubscribe();
    }

    public update(size: number) {
        if (!Number.isFinite(size)) return;
        Graffiti.size.set(Math.max(this.min, Math.min(size, this.max)));
    }
}
